import React from "react";
import { HiMoon, HiSun } from "react-icons/hi";
import { ThemeContext } from "./themeContext";
const Toggle = () => {
  const { theme, setTheme } = React.useContext(ThemeContext);
  return (
    <div className="transition duration-500 ease-in-out rounded-full px-1.25 py-1">
      {theme === "dark" ? (
        <div className="flex strong font-semibold ">
          <HiSun
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="text-gray-500 dark:text-white text-2xl cursor-pointer mr-2"
          />
          <button
            type="button"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="font-semibold dark:text-white"
          >
            {" "}
            Light Mode{" "}
          </button>{" "}
        </div>
      ) : (
        <div className="flex text-gray-900 strong font-semibold">
          <HiMoon
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="text-gray-900 dark:text-gray-400 text-2xl cursor-pointer mr-2 "
          />
          <button
            type="button"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="font-semibold "
          >
            {" "}
            Dark Mode{" "}
          </button>{" "}
        </div>
      )}
    </div>
  );
};
export default Toggle;
